import { Device } from '@iotv/datamodel';
import { v4 } from 'uuid';
import { ConsumerDao } from '../../../../../../data/ConsumerDAO';
import { DeviceDAO } from '../../../../../../data/SystemManagementDAO';
import { Severity } from '../../../../../../types';
const debug = process.env.REACT_APP_DEBUG && false;
export const handleUpdateDevice = async (device, userFunctions, contextCustomer, contextUser) => {
    const res = { err: null, data: null };
    if (contextCustomer && contextUser) {
        const { err, data } = await DeviceDAO.updateDevice({ device, contextCustomer, contextUser });
        if (err || !data) {
            userFunctions.setUserMessage({
                id: v4(),
                type: 'MessageBar',
                severity: Severity.error,
                label: 'Device Management API',
                content: `Failed to update ${device.name ?? device.eui}: ${err?.message ?? 'No response'}`,
            });
            res.err = err;
        }
        if (data) {
            userFunctions.addObjectsToState([device]);
            userFunctions.setUserMessage({
                id: v4(),
                type: 'MessageBar',
                severity: Severity.success,
                label: 'Device Management API',
                content: `Updated ${device.name ?? device.eui}`,
            });
            res.data = data?.Item ?? null;
        }
    }
    else {
        res.err = new Error(`One of contextCustomer or contextUser not present`);
    }
    return res;
};
export const handleDeleteDevice = async (device, userFunctions, contextCustomer, contextUser, getConfirmation) => {
    let deprovision = true;
    const res = { err: null, data: null };
    if (contextCustomer && contextUser) {
        if (new Device(device).isLNC())
            deprovision = await getConfirmation({
                title: 'Deprovision from LNC?',
                question: 'This is an LNC Device, should it also be deprovisioned from LNC?',
                positive: 'Remove & Deprovision',
                alternative: 'Remove',
                neutral: 'Cancel',
            });
        if (deprovision !== null) {
            let removeRes = { err: null, data: null };
            if (deprovision)
                removeRes = await DeviceDAO.deleteDevice({ device, user: contextUser, contextCustomer });
            else
                removeRes = await ConsumerDao.deleteObject(device);
            const { err, data } = removeRes;
            if (err || !data) {
                userFunctions.setUserMessage({
                    id: v4(),
                    type: 'MessageBar',
                    severity: Severity.error,
                    label: 'Device Management API',
                    content: `Failed to delete ${device.name ?? device.eui}${debug ? ` ${err?.message ?? 'No response'}` : ''}`,
                });
                res.err = err;
            }
            if (data) {
                userFunctions.removeObjectsFromState([device]);
                userFunctions.setUserMessage({
                    id: v4(),
                    type: 'MessageBar',
                    severity: Severity.success,
                    label: 'Device Management API',
                    content: `Deleted ${device.name ?? device.eui}${debug ? `(${data.sk})` : ''}`,
                });
                res.data = data;
            }
        }
    }
    else {
        res.err = new Error(`One of contextCustomer or contextUser not present`);
    }
    return res;
};
